const APP_TOAST_EVENT = "angolabi:toast";

let toastSequence = 0;

function createToastPayload(options) {
  return {
    id: options?.id || `toast-${Date.now()}-${toastSequence += 1}`,
    title: options?.title || "",
    message: options?.message || "",
    variant: options?.variant || "info",
    duration: Number.isFinite(options?.duration) ? options.duration : 4200,
  };
}

export function pushToast(options) {
  if (typeof window === "undefined") return "";

  const toast = createToastPayload(options || {});
  window.dispatchEvent(new CustomEvent(APP_TOAST_EVENT, {
    detail: {
      type: "push",
      toast,
    },
  }));

  return toast.id;
}

export function dismissToast(id) {
  if (typeof window === "undefined") return;

  window.dispatchEvent(new CustomEvent(APP_TOAST_EVENT, {
    detail: {
      type: "dismiss",
      id,
    },
  }));
}

export function clearToasts() {
  if (typeof window === "undefined") return;

  window.dispatchEvent(new CustomEvent(APP_TOAST_EVENT, {
    detail: {
      type: "clear",
    },
  }));
}

export const toast = {
  show: pushToast,
  success: (message, options = {}) => pushToast({ ...options, message, variant: "success" }),
  error: (message, options = {}) => pushToast({ ...options, message, variant: "error" }),
  warning: (message, options = {}) => pushToast({ ...options, message, variant: "warning" }),
  info: (message, options = {}) => pushToast({ ...options, message, variant: "info" }),
  dismiss: dismissToast,
  clear: clearToasts,
};

export { APP_TOAST_EVENT };